import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error(
    "Root element not found. Make sure there is a <div id='root'></div> in your HTML."
  );
}

async function enableMocking() {
  // Only enable MSW in development when VITE_MOCK_API is true
  if (import.meta.env.DEV && import.meta.env.VITE_MOCK_API === "true") {
    const { worker } = await import("./test/mocks/browser");
    return worker.start({ onUnhandledRequest: "bypass" });
  }
  return Promise.resolve();
}

void enableMocking().then(() => {
  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
});
